import type { ChatAttachment } from "@researcher/shared";
import MessageAttachments from "./MessageAttachments";

interface UserMessageProps {
  content: string;
  attachments?: ChatAttachment[];
  attachmentPreviewUrls?: Record<string, string>;
  className?: string;
  'data-message-id'?: string;
  'data-message-role'?: string;
}

export default function UserMessage({
  content,
  attachments,
  attachmentPreviewUrls,
  className,
  ...dataAttrs
}: UserMessageProps) {
  return (
    <div className={`flex justify-end ${className ?? ''}`} {...dataAttrs}>
      <div className="max-w-[80%] rounded-2xl p-4 bg-pink-100 dark:bg-pink-900/30 text-gray-800 dark:text-gray-100 rounded-tr-none">
        {content && (
          <p className="text-base leading-relaxed whitespace-pre-wrap text-gray-800 dark:text-gray-100">
            {content}
          </p>
        )}
        {attachments && attachments.length > 0 && (
          <MessageAttachments
            attachments={attachments}
            previewUrls={attachmentPreviewUrls}
          />
        )}
      </div>
    </div>
  );
}
